import React from 'react';
import styled from 'styled-components';
import { getScrollBarStyles } from '../../../config/styles';
import { Button, Icon } from 'semantic-ui-react';
import { theme } from '../../../styles/theme';

export const BackDrop = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  z-index: 1015;
`;

// to calculate left, using 68px for the width of Canvas Control Bar
// to calculate top, using 125px for the height of message input bar
export const Container = styled(({ width, height, ...props }) => (
  <div {...props} />
))`
  padding: 24px;
  position: fixed;
  display: flex;
  z-index: 1015;
  left: ${({ width }) => `calc(50vw - (${width}px / 2) - 68px)`};
  top: ${({ height }) => `calc(50vh - (${height}px / 2) - 125px)`};

  ${getScrollBarStyles(4)}

  & ::-webkit-scrollbar-corner {
    background: rgba(0, 0, 0, 0.5);
    display: none;
  }
`;

export const CanvasRight = styled.div`
  width: fit-content;
  height: fit-content;
`;

export const CanvasImage = styled.div`
  overflow: auto;
  max-width: calc(100vw - 150px);
  max-height: calc(100vh - 250px);
  canvas {
    border-radius: 8px;
  }
`;

export const MessageTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 8px;
`;

// calculate max-width by calculate the Chart Component width dynamically.
export const InputContainer = styled(({ width, ...props }) => (
  <div {...props} />
))`
  margin-top: 12px;
  max-height: 186px;
  width: ${({ width }) => width + 'px'};
  max-width: calc(100vw - 170px);
  padding: 20px;
  border-radius: 8px;
  background-color: #ffffff;
  &&& {
    .editor-features {
      width: auto;
      right: 0;

      button:last-child {
        margin-right: 0;
      }
    }
  }
`;

export const ConfirmButtons = styled.div`
  float: right;
  width: auto;
  margin-top: 36px;
`;

// disable submit button if context length larger than 4000
export const ButtonIcon = styled(Icon)`
  &&& {
    width: 32px;
    height: 32px;
    cursor: pointer;
    border-radius: 16px;
    padding-top: 7px;
    color: ${(props) => (props.defaultChecked ? '#ffffff' : '#999999')};
    background: ${(props) =>
      props.defaultChecked
        ? `linear-gradient(71deg, #123456 -30%, ${theme.colors.mainBlue} 90%);`
        : '#ffffff'};

    &:not(:last-child) {
      margin-right: 16px;
    }
  }
`;

export const CancelDialogContainer = styled.div`
  padding: 22px 32px 32px;
  border-radius: 8px;
  background-color: #ffffff;
  text-align: center;
`;

export const CancelDialogHeader = styled.div`
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  text-align: center;
  color: #333333;
`;

export const CancelDialogSplitter = styled.div`
  margin: 20px 0px 32px;
  height: 1px;
  background-color: #f2f2f2;
`;

export const CancelDialogContent = styled.div`
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  color: #8a94bd;
`;

export const CancelButtonGroup = styled.div`
  margin-top: 32px;
  text-align: center;
  display: inline-flex;
`;

export const DialogCancelButton = styled(({ ...props }) => (
  <Button {...props} />
))`
  &&& {
    margin-right: 24px;
    padding: 8px 16px;
    width: 100px;
    height: 32px;
    border-radius: 4px;
    background-color: #cccccc;
    font: inherit;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    text-align: center;
    color: #ffffff;
  }
`;

export const DialogConfirmButton = styled(({ ...props }) => (
  <Button {...props} />
))`
  &&& {
    width: 100px;
    height: 32px;
    border-radius: 4px;
    background-color: ${theme.colors.mainBlue};
    padding: 8px 16px;
    font: inherit;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1;
    text-align: center;
    color: #ffffff;
  }
`;
